import React, { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { translate } from "reducers/i18n";
import axios from "axios";

export const Error = ({ tenantId, error }) => {
  const [showBackButton, setShowBackButton] = useState(false);
  useEffect(() => {
    axios
      .get(`/api/tenant/${tenantId}`)
      .then((res) => setShowBackButton(res.data.ctaType === "landing"))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div
      style={{
        backgroundColor: "white",
        display: "block",
        padding: "40px 20px",
        margin: "0px",
      }}
    >
      <p>
        {translate("_something_went_wrong")}: &nbsp;
        {error.response?.data?.errorcode
          ? translate(error.response?.data?.errorcode)
          : error.message}
      </p>
      {showBackButton && (
        <button
          className="button primary buttons_fontFamily d-flex align-items-center"
          style={{ padding: "6px 12px" }}
          onClick={() =>
            (window.location.href = window.location.href.split("/login")[0])
          }
        >
          <FiArrowLeft className="m-0 mr-2" />
          <div>{translate("_back")}</div>
        </button>
      )}
    </div>
  );
};
